import apiClient from "./axios"

export const getEmployeeBills = async (params = {}) => {
  const { data } = await apiClient.get("/employee-bills", { params })
  return data
}

export const getMyEmployeeBills = async (params = {}) => {
  const { data } = await apiClient.get("/employee-bills/my-requests", { params })
  return data
}

export const getEmployeeBill = async id => {
  const { data } = await apiClient.get(`/employee-bills/${id}`)
  return data
}

export const createEmployeeBill = async payload => {
  const { data } = await apiClient.post("/employee-bills", payload)
  return data
}

export const createMyEmployeeBill = async payload => {
  const { data } = await apiClient.post("/employee-bills/my-requests", payload)
  return data
}

export const updateEmployeeBill = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/employee-bills/${id}`, payload)
  return data
}

export const deleteEmployeeBill = async id => {
  const { data } = await apiClient.delete(`/employee-bills/${id}`)
  return data
}

export const rejectEmployeeBill = async ({ id, ...payload }) => {
  const { data } = await apiClient.post(`/employee-bills/${id}/reject`, payload)
  return data
}

export const payEmployeeBill = async payload => {
  const { data } = await apiClient.post("/employee-bill-payments", payload)
  return data
}

export const payEmployeeBillBulk = async payload => {
  const { data } = await apiClient.post("/employee-bill-payments/bulk", payload)
  return data
}

export const getEmployeeWallets = async (params = {}) => {
  const { data } = await apiClient.get("/employee-wallets", { params })
  return data
}

export const getMyEmployeeWallet = async () => {
  const { data } = await apiClient.get("/employee-wallets/me")
  return data
}

export const getEmployeeWalletTransactions = async ({ employeeId, ...params }) => {
  const { data } = await apiClient.get(`/employee-wallets/${employeeId}/transactions`, { params })
  return data
}

export const payEmployeeAdvance = async ({ employeeId, ...payload }) => {
  const { data } = await apiClient.post(`/employee-wallets/${employeeId}/advance-payments`, payload)
  return data
}

export const adjustEmployeeWallet = async ({ employeeId, ...payload }) => {
  const { data } = await apiClient.post(`/employee-wallets/${employeeId}/adjustments`, payload)
  return data
}
